import React from "react";
import { Route, Link, withRouter } from "react-router-dom";
import SubserviceItem from "./subserviceItem";
import { visit } from "turbolinks";

class ServiceSubServices extends React.Component {
  constructor(props) {
    super(props);
    this.toggleSelected = this.toggleSelected.bind(this);
  }

  toggleSelected(sub_service) {
    let newState = Object.assign({}, this.props.package_services);
    let newStateSubservices = Object.assign({}, this.props.selectedSubservices);
    let newStateAppointments = Object.assign({}, this.props.appointments);
    let newStatePreviouslyChosen = Object.assign({}, this.props.newStatePreviouslyChosen);
    let newStateVisitedServices = Object.assign({}, this.props.visitedServices)
    let removed = false

    if (this.props.package_services[sub_service.service_id]) {
      if (newState[sub_service.service_id]["package_sub_services_attributes"]){
        if (newState[sub_service.service_id]["package_sub_services_attributes"][sub_service.id]){
          removed = true
          delete newState[sub_service.service_id]["package_sub_services_attributes"][sub_service.id]
          delete newStateSubservices[sub_service.id]
          if (Object.values(newState[sub_service.service_id]["package_sub_services_attributes"]).length === 0){
            delete newStateAppointments[sub_service.service_id]
            delete newState[sub_service.service_id]
            if (newStatePreviouslyChosen[sub_service.service_id]){
              delete newStatePreviouslyChosen[sub_service.service_id]
            }
            // if (newStateVisitedServices[sub_service.service_id]) {
            //   delete newStateVisitedServices[sub_service.service_id]
            // }
          }
          // If a base (non-+) sub-service was removed and no base remains, cascade-remove all + sub-services
          if (!sub_service.title?.startsWith('+')) {
            const remainingBase = Object.values(newStateSubservices).some(
              ss => ss.service_id === sub_service.service_id && !ss.title?.startsWith('+')
            )
            if (!remainingBase) {
              Object.values({...newStateSubservices})
                .filter(ss => ss.service_id === sub_service.service_id && ss.title?.startsWith('+'))
                .forEach(ss => {
                  delete newStateSubservices[ss.id]
                  if (newState[ss.service_id]?.["package_sub_services_attributes"]) {
                    delete newState[ss.service_id]["package_sub_services_attributes"][ss.id]
                  }
                })
              if (newState[sub_service.service_id] &&
                  Object.values(newState[sub_service.service_id]?.["package_sub_services_attributes"] || {}).length === 0) {
                delete newStateAppointments[sub_service.service_id]
                delete newState[sub_service.service_id]
                if (newStatePreviouslyChosen[sub_service.service_id]) {
                  delete newStatePreviouslyChosen[sub_service.service_id]
                }
              }
            }
          }
        } else {
          if (!this.props.addonServices && (this.props.active_service.one_option_allowed || this.props.upgradingPackage)){
            if (this.props.active_service.one_option_allowed && !this.props.upgradingPackage) {
              // Clear any previously selected sub-service for this service from the visible list
              this.props.subservices.forEach((ss) => {
                if (this.props.selectedSubservices[ss.id]){
                  delete newStateSubservices[ss.id]
                  delete newState[sub_service.service_id]["package_sub_services_attributes"][ss.id]
                }
              })
            }
            if (this.props.upgradingPackage && this.props.upgradingSubService) {
              // Only remove the specific sub-service being upgraded — any other
              // independently-selected sub-service on this package (e.g. a second
              // service added alongside it) should be left alone.
              const upgradingId = this.props.upgradingSubService.id
              delete newStateSubservices[upgradingId]
              if (newState[sub_service.service_id]?.["package_sub_services_attributes"]?.[upgradingId]) {
                delete newState[sub_service.service_id]["package_sub_services_attributes"][upgradingId]
              }
            }
          }
          newState[sub_service.service_id]["package_sub_services_attributes"][sub_service.id] = {sub_service_id: sub_service.id}
          newStateSubservices[sub_service.id] = sub_service
        }
      } else {
        newState[sub_service.service_id]["package_sub_services_attributes"] = {[sub_service.id]: {sub_service_id: sub_service.id}}
        newStateSubservices[sub_service.id] = sub_service
      }
    } else {
      newState[sub_service.service_id] = {package_sub_services_attributes: { [sub_service.id]: { sub_service_id: sub_service.id }}}
      newStateSubservices[sub_service.id] = sub_service
    }

    if (!this.props.addonServices && this.props.active_service.one_option_allowed && !removed && !this.props.upgradingPackage){
      if (this.props.new_order_process){
        this.props.changeParentState({
          package_attributes: newState, selectedSubservices: newStateSubservices, appointments: newStateAppointments, previouslyChosen: newStatePreviouslyChosen, addMoreModal: null, visitedServices: newStateVisitedServices
        })
      } else {
        this.props.changeParentState({
          package_attributes: newState, selectedSubservices: newStateSubservices, appointments: newStateAppointments, previouslyChosen: newStatePreviouslyChosen, selected_service: -1, currentlySelectedService: null, addMoreModal: null
        })
        setTimeout(() => {
          this.props.scrollTo(`#service_${this.props.active_service.id}`)
        }, 100);
      }
    } else {
      this.props.changeParentState({
        package_attributes: newState, selectedSubservices: newStateSubservices, appointments: newStateAppointments, previouslyChosen: newStatePreviouslyChosen, visitedServices: newStateVisitedServices
      })
    }
  }

  render() {
    const minUpgradePrice = this.props.minUpgradePrice ?? null

    const upgradingSubServiceId = this.props.upgradingSubService?.id

    const hasBaseSelected =
      this.props.currentUser?.roles?.admin ||
      Object.values(this.props.selectedSubservices).some(
        ss => ss.service_id === this.props.active_service?.id && !ss.title?.startsWith('+')
      ) ||
      Object.values(this.props.previousSubservices || {}).some(
        ss => ss.service_id === this.props.active_service?.id && !ss.title?.startsWith('+')
      )

    let subserviceLis = this.props.subservices?.filter(sub_service => !sub_service.promo).filter(sub_service => this.props.addonServices ? sub_service.addon : !sub_service.addon).filter(sub_service => !this.props.previousSubservices?.[sub_service.id]).filter(sub_service => {
      if (!this.props.upgradingPackage) return true
      // Hide sub-services already on the project (other than the one being replaced)
      if (sub_service.id !== upgradingSubServiceId && this.props.project?.invoice_sub_services?.[sub_service.id]) return false
      return true
    }).filter(sub_service => {
      if (minUpgradePrice === null) return true
      let price = parseFloat(this.props.location_pricing?.[sub_service.id]?.price || sub_service.price)
      return price >= minUpgradePrice
    }).map((subservice) => <SubserviceItem key={subservice.id} project={this.props.project} new_update_process={this.props.new_update_process} new_order_process={this.props.new_order_process} location_pricing={this.props.location_pricing} subservice={subservice} selected={this.props.selectedSubservices[subservice.id] != null} toggleSelected={this.toggleSelected} homepage={this.props.homepage} hasBaseSelected={hasBaseSelected} /> ) || []

    return (
      <div className="subServicesComponent">
        <div className="subServiceGrouping">
          {subserviceLis}
        </div>
      </div>
    )
  }
}

export default withRouter(ServiceSubServices);
